<template>
  <div class="left-menu">
    <h1 class="title-report">Звіти</h1>
    <span class="text">Період з:</span>
    <div class="period">
      <div class="right-inner-addon">
        <date-picker  v-bind:value="value" v-on:input="$emit('input', $event)" format="DD.MM.YYYY" :lang="lang" :disabled-date="disabledAfterToday"></date-picker>
      </div>
    </div>
<!--    <ul class="menu">-->
<!--      <li><router-link to="/service-results">ПІДСУМКИ ОБСЛУГОВУВАННЯ</router-link></li>-->
<!--      <li><router-link to="/payments">ОПЛАТА</router-link></li>-->
<!--      <li v-if="$store.state.schemeType !== 0"><router-link to="/rep_cards">ПОПОВНЕННЯ КАРТОК</router-link></li>-->
<!--      <li><router-link to="/service">ОБСЛУГОВУВАННЯ</router-link></li>-->
<!--    </ul>-->
  </div>
</template>
<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/uk';
import  moment from "moment";
moment.defineLocale('uk', null)
export default {
  name: 'ReportMenu',
  props: ["value"],
  components: {
    DatePicker
  },
  methods: {
    disabledAfterToday(date){
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date > today
    }
  },
  data() {
    return {
      lang: {
        monthFormat: 'MMMM'
        // formatLocale: {
        //   firstDayOfWeek: 1,
        // },
        // monthBeforeYear: false,
      },
    }
  }
}
</script>
<style>
.left-menu {
  width: 20%;
}
.mx-calendar-content .cell.active {
  background-color: #222160;
}
.mx-calendar-content .cell.in-range, .mx-calendar-content .cell.hover-in-range {
  color: #73879c;
  background-color: var(--active-purple);
}
.period {
  display: flex;
  margin-top: 10px;
  max-width: 320px;
}
.period  input {
  background:  var(--usual-white);
  border: 1px solid  var(--strong-grey);
  box-sizing: border-box;
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 13px;
  line-height: 19px;
  /* or 146% */
  text-align: center;
  text-transform: capitalize;
  font-feature-settings: 'cpsp' on;;
//height: 36px;
//width: 130px;
  border-radius: 0px;
  padding: 9px 30px 9px 9px;
  //margin: 5px;
}
.period input:focus,
.period input:hover
{
  outline: none;
//box-shadow: 0px 0px 4px #4E4CC7;
  border: 1px solid  var(--soft-purple);
}
.router-link-active {
  color: var(--soft-purple);
}
ul.menu li {
  list-style-type: none;
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 13px;
  line-height: 19px;
  /* or 146% */

  text-transform: uppercase;
  font-feature-settings: 'cpsp' on;
  padding-bottom: 10px;
  padding-top: 10px;
  border-bottom: 1px solid #C4C4C4;

}
ul.menu {
//margin-top: 55px;
  padding: 0;
  border-top: 1px solid #C4C4C4;
  max-width: 320px;
}
.title-report {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 50px;
  line-height: 19px;
  /* identical to box height, or 38% */

  color: #222160;
}
.right-inner-addon{
  position:relative;
  padding:0;
  margin:0;
  display: flex;
  width: 100%;
}
.left-menu .text {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 13px;
  line-height: 19px;
  /* or 146% */
  font-feature-settings: 'cpsp' on;
  color: #222160;
}
</style>